module.exports = __webpack_public_path__ + "img/bg6.3f92e87f.png";